/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Roles_Permissions_SavedInputs */

const en_admin_roles_permissions_saved = /** @type {(inputs: Admin_Roles_Permissions_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permissions updated`)
};

/**
* | output |
* | --- |
* | "Permissions updated" |
*
* @param {Admin_Roles_Permissions_SavedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_roles_permissions_saved = /** @type {((inputs?: Admin_Roles_Permissions_SavedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Roles_Permissions_SavedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_roles_permissions_saved(inputs)
});
export { admin_roles_permissions_saved as "admin.roles.permissions_saved" }